import React from 'react';
import {
    getStatusOpName,
    OP_STATUS,
    supportSteps
} from "../../../../../util/varibles/constants";
import { IOperation2, ISupportOp2 } from "../../../../../util/varibles/interface";
import SiteDisease from '../../../../Operation/FishDisease/SiteDisease';
import Locations from "../../../../Operation/Locations2";
import ActivityLog from "../../_component/AcitivtyLog";
import ApproveControl from "../../_component/ApproveControl";
import Approver from "../../_component/Approver";
import BoxOpInfo from "../../_component/BoxOpInfo";
import Columns from '../../_component/Columns';
import TimeDuration from '../../_component/Duration/TimeDuration';
import Status from "../../_component/Status";
import Header from "../../Header";
import { callEventPopupOpInfo } from '../../PopupOpInfoContext';
import stylesContainer from "../../style.module.scss";

interface IProps {
    isEdit: boolean
    isApprove: boolean
    data: IOperation2<ISupportOp2>
}

const Support: React.FC<IProps> = (props) => {
    const {
        data,
        isEdit,
        isApprove,
    } = props;
    const { updateNote, changeState } = callEventPopupOpInfo();
    const { operation, activity_log } = data;
    const { current_process, locations, status } = operation;
    const statusText = status === OP_STATUS.PROCESSING ? supportSteps[current_process]?.name : getStatusOpName(status);

    return <>
        <Header operation={operation}>
            <div className={stylesContainer.title}>
                <div className='ml-3 flex align-items-center'>
                    <Status {...{ status, statusText }} />
                    <Locations className='ml-5' locations={locations} />
                </div>
            </div>
        </Header>

        <div className={stylesContainer.body}>
            <ActivityLog />
        </div>
        <BoxOpInfo data={data} isEdit={isEdit} handleUpdateNote={updateNote}>
            <Columns className="mb-2" content={[
                <>
                    <TimeDuration activity_log={activity_log} />
                    <ApproveControl {...{ isApprove, operation, handleChangeState: changeState }} />
                    <Approver operation={operation} />
                </>,
                <SiteDisease diseases={operation.diseases || []} />
            ]} />
        </BoxOpInfo>
    </>;
};

export default Support;